const updates = [
  { id: 1, date: '2026-07-31', title: '《庆余年》第二季全集更新完成，48集高清完整版上线', tag: '剧集更新' },
  { id: 2, date: '2026-07-30', title: '新增韩剧专区，收录《黑暗荣耀》《财阀家的小儿子》等热门韩剧全集', tag: '内容上新' },
  { id: 3, date: '2026-07-28', title: '播放器全面升级，支持4K超清画质与智能倍速播放功能', tag: '功能升级' },
  { id: 4, date: '2026-07-25', title: '《莲花楼》全集上线，成毅武侠探案力作，40集一次看完', tag: '剧集更新' },
  { id: 5, date: '2026-07-22', title: '移动端追剧体验优化，降低流量消耗，弱网环境也能流畅播放', tag: '体验优化' },
  { id: 6, date: '2026-07-18', title: '悬疑剧场板块上线，收录《白夜追凶》《隐秘的角落》等高分悬疑剧', tag: '内容上新' },
  { id: 7, date: '2026-07-15', title: '《长相思》全集上线，杨紫领衔仙侠大剧，口碑热度双丰收', tag: '剧集更新' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">最新动态 · 网站更新快讯</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">被窝网电影持续更新，第一时间了解最新剧集与功能动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={item.id} className="flex gap-4 pb-6 last:pb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5"></div>
                {idx < updates.length - 1 && <div className="w-px flex-1 bg-background-200 mt-1"></div>}
              </div>
              <div className="flex-1 pb-2">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                    item.tag === '剧集更新' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '内容上新' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}